export default __webpack_public_path__ + "static/rsz_rsz_marek_z-4af9fd242914ba39cc236343b88886a5.jpg";